module.exports = __webpack_public_path__ + "static/media/games-icon.9897350f.svg";